import { NodeViewProps } from '@tiptap/core'
import { NodeViewWrapper } from '@tiptap/react'

import { PollComponent } from '../../../Poll/PollComponent.js'

export function PollNodeContent(props: NodeViewProps) {
  const { node, HTMLAttributes } = props

  return (
    <NodeViewWrapper {...HTMLAttributes} className="mx-2 mt-1 mb-3">
      <PollComponent interactive={false} id={node.attrs.id} hideResult />
    </NodeViewWrapper>
  )
}
